import { useContext } from 'react';
import { Proxy } from 'signalr-no-jquery';
import { SignalrContext } from 'stores';

export function useSignalr(): (Proxy & { events?: any }) | undefined {
  const { hubProxy } = useContext(SignalrContext);

  return hubProxy;
}

export default useSignalr;
